import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { 
		clsx
	} from 'clsx'
	
	import {
		DialogTitle
	} from '@headlessui/vue'

	import { 
		localesStore
	} from '@/store/locales'

	// eslint-disable-next-line
	
	const __default__ = { name: 'VDialogTitle' } // name the component
  
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		className: {
			type: String,
			default: ""
		}
	},
  setup(__props) {

	const props = __props

	const _localesStore = localesStore()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DialogTitle), {
    class: _normalizeClass(_unref(clsx)(__props.className, _unref(_localesStore).locales.selected == 'en' ? 'font-semibold' : 'font-medium', 'text-balance text-lg/6 text-zinc-950 sm:text-base/6 dark:text-white'))
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["class"]))
}
}

})